import { waitForActiveRoomOutboundSend } from './canvasRoomPool'

export const APP_RELOAD_REQUESTED_EVENT = 'dw:app-reload-requested'
export const APP_RELOAD_DRAIN_TIMEOUT_MS = 300

interface CoordinateAppReloadOptions {
  target?: EventTarget
  waitForOutboundSend?: typeof waitForActiveRoomOutboundSend
  reload?: () => void
}

/** Flush in-memory editors, best-effort send queued Yjs bytes, then replace the document. */
export async function coordinateAppReload({
  target = window,
  waitForOutboundSend = waitForActiveRoomOutboundSend,
  reload = () => window.location.reload(),
}: CoordinateAppReloadOptions = {}): Promise<void> {
  target.dispatchEvent(new Event(APP_RELOAD_REQUESTED_EVENT))
  try {
    await waitForOutboundSend(APP_RELOAD_DRAIN_TIMEOUT_MS)
  } finally {
    // A stale/closing provider must not strand the user on the old build after
    // editors have already flushed their in-memory state.
    reload()
  }
}
